import { JobEntity, JobOperation } from '@commenda/api';
import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { Button, Dropdown, Icons, useToggle } from '@commenda/kakashi';
import { JobsLogTable, useIndirectTaxJobWatcher } from '../common/jobs';

const ProductTabHeader = ({
  onAddProduct,
  onImportProducts,
  onConnectIntegration,
  corporationId,
}: {
  onAddProduct: () => void;
  onImportProducts: () => void;
  onConnectIntegration: () => void;
  corporationId: number;
}) => {
  const isRootfiIntegrationEnabled = isFeatureLaunched(
    FeatureLaunch.SALES_TAX_ROOTFI_INTEGRATION
  );

  const { getJobsByEntityAndOperation: getImportJobs } =
    useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity: JobEntity.PRODUCT,
    operation: JobOperation.IMPORT,
  });

  const { getJobsByEntityAndOperation: getExportJobs } =
    useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity: JobEntity.PRODUCT,
    operation: JobOperation.EXPORT,
  });

  const importJobTableVisibility = useToggle();
  const exportJobTableVisibility = useToggle();

  return (
    <div className="flex items-center justify-between gap-2 my-3xl">
      <div className="flex items-center gap-2 w-full justify-end">
        <Dropdown
          menu={{
            groups: [
              {
                items: [
                  {
                    icon: Icons.Download01,
                    label: 'View import logs',
                    onClick: importJobTableVisibility.show,
                  },
                  {
                    icon: Icons.Upload01,
                    label: 'View export logs',
                    onClick: exportJobTableVisibility.show,
                  },
                ],
              },
            ],
          }}
          align="end"
        >
          <Button variant="tertiary" size="sm">
            View product reports
          </Button>
        </Dropdown>

        <Dropdown
          align="end"
          menu={{
            groups: [
              {
                items: [
                  isRootfiIntegrationEnabled && {
                    icon: Icons.Link01,
                    label: 'Connect integration',
                    onClick: onConnectIntegration,
                  },
                  {
                    icon: Icons.Download01,
                    label: 'Import products',
                    onClick: onImportProducts,
                  },
                ],
              },
            ],
          }}
        >
          <Button variant="secondary" size="sm">
            <Icons.Plus className="size-4" />
            <span>Add product</span>
          </Button>
        </Dropdown>
      </div>

      <JobsLogTable
        isOpen={importJobTableVisibility.visible}
        onClose={importJobTableVisibility.hide}
        data={getImportJobs(JobEntity.PRODUCT, JobOperation.IMPORT)}
        corporationId={corporationId}
        title="Product Reports"
      />

      <JobsLogTable
        isOpen={exportJobTableVisibility.visible}
        onClose={exportJobTableVisibility.hide}
        jobOperation={JobOperation.EXPORT}
        data={getExportJobs(JobEntity.PRODUCT, JobOperation.EXPORT)}
        corporationId={corporationId}
        title="Product Reports"
      />
    </div>
  );
};

export default ProductTabHeader;
